var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setInfoMessage } from '@popup/multichain/actions/message.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { TokenSwapsHistoryItemComponent } from '@popup/steem/pages/app-container/home/swaps/token-swaps-history/token-swaps-history-item/token-swaps-history-item.component';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import 'react-tabs/style/react-tabs.scss';
import { SVGIcons } from 'src/common-ui/icons.enum';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import Config from 'src/config';
import { SwapTokenUtils } from 'src/utils/swap-token.utils';
const TokenSwapsHistory = ({ activeAccount, setTitleContainerProperties, setInfoMessage, }) => {
    const [history, setHistory] = useState([]);
    const [autoRefreshCountdown, setAutoRefreshCountdown] = useState(null);
    const [shouldRefresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'html_popup_token_swaps_history',
            isBackButtonEnabled: true,
        });
        initSwapHistory();
    }, []);
    useEffect(() => {
        if (autoRefreshCountdown === null) {
            return;
        }
        if (autoRefreshCountdown === 0) {
            refresh();
            setAutoRefreshCountdown(Config.swaps.autoRefreshHistoryPeriodSec);
            return;
        }
        const intervalId = setInterval(() => {
            setAutoRefreshCountdown(autoRefreshCountdown - 1);
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, [autoRefreshCountdown]);
    const initSwapHistory = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield refresh();
        setLoading(false);
    });
    const refresh = () => __awaiter(void 0, void 0, void 0, function* () {
        setRefresh(true);
        const result = yield SwapTokenUtils.retrieveSwapHistory(activeAccount.name);
        setHistory(result);
        setAutoRefreshCountdown(Config.swaps.autoRefreshHistoryPeriodSec);
        setRefresh(false);
    });
    if (loading)
        return (React.createElement("div", { className: "rotating-logo-wrapper" },
            React.createElement(RotatingLogoComponent, null)));
    return (React.createElement("div", { className: "token-swaps-history" },
        React.createElement("div", { className: "refresh-panel" }, !!autoRefreshCountdown && (React.createElement(React.Fragment, null,
            getMessage('swap_refresh_countdown', [
                autoRefreshCountdown === null || autoRefreshCountdown === void 0 ? void 0 : autoRefreshCountdown.toString(),
            ]),
            React.createElement(SVGIcon, { className: `swap-history-refresh ${shouldRefresh ? 'rotate' : ''}`, icon: SVGIcons.SWAPS_HISTORY_REFRESH, onClick: refresh })))),
        React.createElement("div", { className: "history" },
            history.length > 0 &&
                history.map((item, index) => {
                    return (React.createElement(TokenSwapsHistoryItemComponent, { key: `item-${index}`, swap: item }));
                }),
            history.length === 0 && (React.createElement("div", { className: "empty-history-panel" },
                React.createElement(SVGIcon, { icon: SVGIcons.MESSAGE_ERROR }),
                React.createElement("span", { className: "text" }, getMessage('swap_no_history')))))));
};
const mapStateToProps = (state) => {
    return { activeAccount: state.steem.activeAccount };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
    setInfoMessage,
});
export const TokenSwapsHistoryComponent = connector(TokenSwapsHistory);
